import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieGrid from "@/components/feature/MovieGrid";
import { getLatestMovies } from "@/utils/movie";

const tabs = ["全部", "动作", "爱情", "科幻", "喜剧", "悬疑"];

export default function LatestMovies() {
  const [activeTab, setActiveTab] = useState("全部");
  const latest = useMemo(() => getLatestMovies(20), []);

  const list = useMemo(() => {
    if (activeTab === "全部") return latest.slice(0, 10);
    return latest.filter((movie) => movie.genres.includes(activeTab)).slice(0, 10);
  }, [activeTab, latest]);

  return (
    <section className="mt-10">
      <SectionHeading
        icon="ri-time-line"
        title="最新电影"
        subtitle="按更新时间倒序排列，新鲜资源第一时间看"
        action={
          <Link
            to="/search"
            className="hidden items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 sm:flex cursor-pointer whitespace-nowrap"
          >
            更多电影
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="mb-5 flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeTab === tab
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <MovieGrid movies={list} emptyText="该分类下暂无最新影片" />
    </section>
  );
}